<template>
    <div :class="{container: true, noscroll: modalVisable}">
        <div class="header" />
        <img
            v-for="(section, index) in lazyUrlList.section.slice(0,3)"
            :key="'section-0-'+index"
            v-lazy="section"
            :class="`section section-${index+1}`"
        >
        <div
            class="section section-4"
        >
            <lazy-component>
                <ul>
                    <li
                        v-for="(item, index) in sortStageList"
                        :key="index"
                        :class="getStepClass(index)"
                        @click="showModal(index)"
                    >
                        <img
                            :src="lazyUrlList.stepUrl[index]"
                            alt=""
                            srcset=""
                        >
                    </li>
                </ul>
            </lazy-component>
        </div>

        <img
            v-for="(section, index) in lazyUrlList.section.slice(3)"
            :key="'section-1-'+index"
            v-lazy="section"
            :class="`section section-${index+5}`"
        >

        <div
            class="fixed-bar"
            :style="footerBtn"
        >
            <div
                class="btn"
                @click="jumpTo"
            />
        </div>
        <div
            :class="{'modal-container': true, active: modalVisable}"
        >
            <div
                :class="{'layer': true, active: modalVisable}"
            />
            <div class="modal">
                <div

                    :class="{'modal-content': true, active: modalVisable}"
                >
                    <div class="close-container">
                        <div
                            class="close"
                            @click="closeModal"
                        />
                    </div>
                    <div class="title">
                        {{ sortStageList[current] && sortStageList[current].desc }}
                        <div class="sub-title">
                            {{ sortStageList[current] && sortStageList[current].title }}
                        </div>
                    </div>
                    <div
                        v-if="sortStageList[current]"
                        v-touch-fix
                        class="scroll-content"
                    >
                        <div
                            v-for="(item, index) in sortStageList[current].detail"
                            :key="index"
                            class="scroll-item"
                        >
                            <div class="scroll-item-title">
                                {{ item.title }}
                            </div>
                            <ul
                                v-for="(t, idx) in item.content"
                                :key="idx"
                                class="scroll-item-desc"
                            >
                                <li>{{ t }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import common from '../../frontend/components/common';
import { footerCom } from '../../../uitl/618.js';
import touchFix from '../../../uitl/touchmoveFix';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import axios from '../../../service/index';
import List from './list'
export default {
    name: 'JavaJaGouShiH5',
    directives: {
        touchFix
    },
    mixins: [ footerCom],
    data() {
        return {
            current: 0,
            countDownTime: 0,
            modalVisable: false,
            countText: '',
            sortStageList: [],
            selfTop: 0,
            isStart: false,
            lazyUrlList: {
                stepUrl: [],
                section: []
            },
            List,
        };
    },
    mounted() {
        document.title = '大前端高薪训练营';
    },
    created() {
        // 取得大前端高薪训练营 课程列表
        this.lazyUrlList = this.List?.data?.lazyUrlh5List || {
            partUrl: [],
            section: []
        };
        this.stageList = this.List?.data?.stageList || [];
        this.sortStageList = this.stageList
        // axios.get('/kw/adam/ad/detail/newfedList').then(res => {
        //     this.lazyUrlList = res.data?.data?.lazyUrlh5List || {
        //         partUrl: [],
        //         section: []
        //     };
        //     this.stageList = res.data?.data?.stageList || [];
        //     this.sortStageList = this.stageList
        // }).catch(error => {
        //     console.log(error);
        // });
    },
    methods: {
        startPlay() {
            this.isStart = true;
            this.$refs.javaVideo.play();
        },
        getStepClass(index) {
            return `step step-${index}`;
        },
        gblen(str) {
            var len = 0;
            for (var i = 0; i < str.length; i++) {
                if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
                    len += 2;
                } else {
                    len++;
                }
            }
            return len;
        },
        fixedBody() {
            this.selfTop = document.body.scrollTop || document.documentElement.scrollTop;
            document.body.style.cssText += 'position:fixed;overflow: hidden;height: auto;top: -' + this.selfTop + 'px';
        },
        looseBody() {
            var body = document.body;
            body.style.overflow = 'auto';
            body.style.height = 'auto';
            body.style.position = '';
            document.body.scrollTop = document.documentElement.scrollTop = parseInt(this.selfTop);

        },
        showModal(index) {
            this.fixedBody();

            this.current = index;
            this.modalVisable = true;
        },
        jumpTo() {
            this.eduPlatTrack('WebButtonClick', {
                'page_id': '1pxi',
                'button_name': '领取前端成长路线'
            });
            handleJumpUrl(`75022597f6fb4408ae50310a1a551964`);
        },
        closeModal() {
            this.looseBody();
            this.modalVisable = false;
        }
    }
};
</script>

<style
    lang='less'
    scoped
>

    .bgUrl(@img) {
        background: url('../../frontend/assets/img/h5/@{img}') top center no-repeat;
        background-size: cover;
    }

    .container {
        padding-bottom: 120px;
        font-size: 0;
        /* height: auto;
        overflow: auto;
        &.noscroll {
            height: 100%;
            overflow: hidden;
        } */
    }

    .header {
        width: 750px;
        height: 868px;
        background: url('https://s20.lgstatic.com/growth/activity/20210802/1627886812489.jpg') top center no-repeat;
        background-size: cover;
    }

    .section {
        width: 750px;

        &.section-June {
            height: 1320px;
            padding: 30px 30px 0;
            background-color: #f6f6f6;
            box-sizing: border-box;
            .imgbg {
                height: 1320px;
                border-radius: 4px;
                .bgUrl('monthPlan.png');
                background-size: contain;
            }
        }


        &.section-4 {
            overflow: hidden;
            padding-bottom: 50px;
            text-align: center;
            background: #F7F4F8;
            .step{
                margin: 0 auto 0px;
                text-align: right;
                width: 690px;
            }
            img{
                width: 100%;
                height: 100%;
            }
            .step-btn{
                width:151px;
                height: 74px;
                border: none;
                position: relative;
                top: 42px;
                right: 23px;
                .bgUrl('step-btn.png');
            }
            .link-btn {
                height: 195px;
                width: 100%;
                outline: none;
                .bgUrl('check-learn-detail.png');
            }
        }
    }

    .fixed-bar {
        width: 750px;
        height: 126px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 9;
        .bgUrl('fixed-bar.png');
        .btn {
            width: 670px;
            height: 90px;
            text-align: center;
            color: #fff;
            font-size: 32px;
            line-height: 90px;
            border-radius: 90px;
            outline: none;
        }
    }
    .layer {
        position: fixed;
        z-index: 1;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.6);
         display: none;
        &.active {
            display: block;
        }
    }
    .modal {
        position: fixed;
        bottom: 119px;
        z-index: 3;
        display: flex;
        justify-content: center;
        .modal-content {
            width: 750px;
            height: 0;
            opacity: 0;
            transition: height .3s;
            &.active {
                opacity: 1;
                height: 962px;
            }
            background: #fff;
            border-radius: 18px 18px 0 0;
            position: relative;

            margin-right: 45px;
            box-sizing: border-box;
        }

        .close {
            width: 52px;
            height: 52px;
            background: url("https://s21.lgstatic.com/growth/activity/20210201/1612149111223.png") no-repeat center;
            background-size: 42px 42px;
            position: absolute;
            right: 18px;
            top: 18px;
            border-radius: 50%;
        }

        .title {
            margin-top: 82px;
            width: 658px;
            font-size: 32px;
            line-height: 40px;
            margin-bottom: 41px;
            padding-left: 45px;
            font-weight: bold;
            &-dot {
                width: 5px;
                height: 5px;
                border-radius: 5px;
                background: #FA4000;
            }
            .sub-title{
                color: #C69C6D;
                font-size: 26px;
                margin-top: 8px;
            }
        }

        .scroll-content {
            height: 790px;
            overflow-y: scroll;

            .scroll-item {
                font-size: 28px;
                line-height: 36px;
                margin-bottom: 27px;
                &:last-child{
                    margin-bottom: 50px;
                }
            }

            .scroll-item-title {
                margin-bottom: 26px;
                font-weight: bold;
                color: #191F34;
                position: relative;
                padding-left: 47px;
                font-size: 26px;
                line-height: 28px;

                &:before {
                    content: '';
                    width: 8px;
                    height: 8px;
                    background: #C69C6D;
                    border-radius: 8px;
                    position: absolute;
                    left: 25px;
                    top: 11px;
                }
            }
            .scroll-item-desc {
                margin-bottom: 26px;
            }
            li {
                margin-bottom: 20px;
                color: #5E6476;
                font-size: 26px;
                padding-left: 48px;
            }
        }
    }
    /*@supports(padding-top: constant(safe-area-inset-bottom)) or (padding-top: env(safe-area-inset-bottom)) {*/
    /*    .container,.fixed-bar {*/
    /*        margin-bottom: constant(safe-area-inset-bottom);*/
    /*        margin-bottom: env(safe-area-inset-bottom);*/
    /*    }*/

    /*}*/
</style>
